/* Garage Utility homepage behaviour. Product data is in the PRODUCTS array below. */
import Lenis from "lenis";

/* ============================================================
   CATALOG — mirrors the live store as of the last sync.
   Update prices/handles here if they change in Shopify.
   ============================================================ */
const SHOP = "https://garageutility.com";
const P = (h) => SHOP + "/products/" + h;

const PRODUCTS = [
  // ---- Portable Power ----
  { cat:"portable", brand:"Dark Energy", name:"Recon 2000 Power Station", spec:"2016Wh · 2400W pure sine · rugged field build",
    price:1999.99, from:false, stock:true, handle:"recon-2000-power-station",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/r2000.webp?v=1788681558", featured:true },
  { cat:"portable", brand:"Nature's Generator", name:"Lithium 6000 Power Pod", spec:"Expansion battery for the Lithium 6000",
    price:1499.99, from:false, stock:true, handle:"natures-generator-lithium-6000-power-pod",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/Lithium_6000_Power_Pod.png?v=1788673134" },
  { cat:"portable", brand:"Arkpax", name:"Ark 1800W Waterproof Power Station", spec:"1500Wh · 1800W · IP67 · 2-hour recharge",
    price:949.00, from:false, stock:true, handle:"arkpax-ark-1800w-ip67-waterproof-power-station",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/U1800_1.jpg?v=1788681629", featured:true },
  { cat:"portable", brand:"Dark Energy", name:"Spectre 200W Solar Panel", spec:"Folding array for off-grid charging",
    price:549.99, from:false, stock:true, handle:"spectre-200w-solar-panel",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/0000_S200W-Folded.webp?v=1788682322" },
  { cat:"portable", brand:"Nature's Generator", name:"Elite Power Pod", spec:"Expansion battery for the Elite system",
    price:499.99, from:true, stock:true, handle:"natures-generator-elite-power-pod",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/natures-generator-elite-power-pod-839155.png?v=1788681644" },
  { cat:"portable", brand:"GOFORT", name:"330W Portable Power Station", spec:"299Wh · QC 3.0 · solar-panel ready",
    price:480.50, from:false, stock:true, handle:"gofort-330w-portable-power-station-299wh-solar-generator-backup-power-compatible-with-100w-18v-portable-solar-panel-foldable-solar-charger-with-usb-18v-d-c-qc-3-0-output",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/dspic_7c0adbfb-36ee-4443-bff3-723b23288dae.jpg?v=1788681664" },
  { cat:"portable", brand:"Dark Energy", name:"Spectre 56W Solar Panel", spec:"IPX7 waterproof · crush tested",
    price:349.99, from:false, stock:true, handle:"spectre-56w-solar-panel",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/0001_Layer-7.webp?v=1788682306" },
  { cat:"portable", brand:"Tesery", name:"RovEdge Mk-I Power Tripod", spec:"189Wh · Starlink Mini compatible",
    price:289.00, from:false, stock:false, handle:"rovedge-mk-i-189wh-portable-power-tripod-compatible-with-starlink-mini-battery-pack",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/189wh-portable-power-tripod-compatible-with-starlink-mini-battery-pack-9515966.png?v=1788681684" },
  { cat:"portable", brand:"Dark Energy", name:"Poseidon XL Power Bank", spec:"100W USB-C input · built for hard use",
    price:249.99, from:false, stock:false, handle:"poseidon-xl-power-bank",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/0005_PXL-Top-Down-Front_5ac9ee7b-8c63-4518-a2eb-91366a4397a7.webp?v=1788682339" },

  // ---- Home Backup ----
  { cat:"backup", brand:"Nature's Generator", name:"MyGrid 10K Solar Generator", spec:"Whole-home bundle with bifacial panels",
    price:7699.99, from:true, stock:true, handle:"mygrid-10k-solar-generator-for-home",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/MyGrid_8_Panels_-_Clear.png?v=1786473692" },
  { cat:"backup", brand:"Nature's Generator", name:"Powerhouse Gen 2 Solar + Transfer Switch", spec:"Includes 240V 12-circuit manual transfer switch",
    price:4149.99, from:true, stock:true, handle:"powerhouse-gen-2-solar-generator-and-transfer-switch",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/Powerhouse_with_2x_410W_Rigid_Panel_and_240V_12-Circuit_MTS_1500x1500_3d01cc36-8709-4fff-adb9-d50d31a58484.png?v=1788682362", featured:true },
  { cat:"backup", brand:"Nature's Generator", name:"Powerhouse Gen 2 Whole Home Solar Generator", spec:"7200W · 4800Wh · bundled rigid panels",
    price:3749.99, from:true, stock:true, handle:"powerhouse-gen-2-whole-home-solar-generator",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/Powerhouse_Solar_Generator_1500x1500_f0352be4-6006-45ba-9859-3944d8f14172.png?v=1788673115" },
  { cat:"backup", brand:"Nature's Generator", name:"Powerhouse Gen 2 Whole Home Generator", spec:"120/240V · 7200W · 4800Wh pure sine",
    price:2799.99, from:true, stock:true, handle:"powerhouse-gen-2-whole-home-generator",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/Powerhouse_V2_Front.png?v=1788673143" },
  { cat:"backup", brand:"Nature's Generator", name:"440W Monocrystalline Solar Panel (2-Pack)", spec:"880W combined array capacity",
    price:999.99, from:false, stock:true, handle:"440-watt-monocrystalline-solar-panel-2-pack",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/410-watt-monocrystalline-solar-panel-2-pack-548731.png?v=1788682402" },
  { cat:"backup", brand:"Victron Energy", name:"SmartSolar MPPT 100/50 Charge Controller", spec:"100V · 50A · Bluetooth · DC side only",
    price:193.80, from:false, stock:true, handle:"victron-smartsolar-mppt-100-50-scc110050210",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/B073ZJ43L1.MAIN.SCC110050210.jpg?v=1788682416" },

  // ---- EV Charging ----
  { cat:"ev", brand:"Autel", name:"MaxiCharger 80A 19.2kW Residential", spec:"80A · up to 70 miles of range per hour",
    price:1039.20, from:false, stock:true, handle:"maxicharger-80a-19-2kw-residential-ev-charger",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/01_-_AC_80A-inbody.png?v=1788682228" },
  { cat:"ev", brand:"EVIQO", name:"NACS Level 2 EV Charger, 48A", spec:"240V hardwired · 11.5kW · for Tesla",
    price:480.00, from:true, stock:true, handle:"eviqo-nacs-level-2-ev-charger-48a-50a-max-240v-hardwired-for-tesla-evs",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/MAIN.HARDWIERED.webp?v=1788682181", featured:true },
  { cat:"ev", brand:"EVIQO", name:"J1772 Level 2 EV Charger, 48A", spec:"240V hardwired · 11.5kW · non-Tesla",
    price:429.99, from:true, stock:true, handle:"eviqo-level-2-ev-charger-48a-50a-max-240v-hardwired-j1772-for-non-tesla-evs",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/EVIQO_J1772_Hardwired_Level_2_Charger.webp?v=1788682215" },
  { cat:"ev", brand:"WenStorm", name:"J1772 EV Extension Cable", spec:"32A and 50A · 21ft to 40ft",
    price:129.99, from:true, stock:true, handle:"wenstorm-j1772-ev-extension-cable-for-level-2-charging",
    img:"https://cdn.shopify.com/s/files/1/0986/0448/2866/files/af298e61.jpg?v=1788682247" }
];

const CATS = [
  { key:"portable", n:"01", title:"Portable Power", href:SHOP+"/collections/portable-power",
    desc:"Power stations, expansion batteries and folding solar you can carry." },
  { key:"backup", n:"02", title:"Home Backup", href:SHOP+"/collections/home-backup",
    desc:"Whole-home generators, transfer switches and the panels that feed them." },
  { key:"ev", n:"03", title:"EV Charging", href:SHOP+"/collections/ev-charging",
    desc:"Level 2 chargers in J1772 and NACS, plus cables and adapters." }
];

const STANDARDS = [
  ["Built for U.S. wiring","Split-phase 240V, 60 Hz, and a UL or ETL listing. Plenty of good equipment is built for 230V single-phase at 50 Hz — it will not work on an American panel, and we do not list it.","Voltage and listing checked"],
  ["Specs, not adjectives","Continuous watts and surge watts. Breaker size and wire gauge. Real runtime at a real load. The numbers that decide whether something fits your garage.","Plainly listed"],
  ["Answers before the sale","Ask what a 48A charger needs at the panel, or whether an inverter will start your compressor. A real answer beats a return, and it costs you nothing to ask.","Email support@garageutility.com"]
];

const RM = matchMedia("(prefers-reduced-motion: reduce)").matches;
const EASE = { expo:"cubic-bezier(0.16,1,0.3,1)", quart:"cubic-bezier(0.25,1,0.5,1)", cubic:"cubic-bezier(0.65,0,0.35,1)" };
const canHover = () => innerWidth > 768;
const money = n => "$" + n.toLocaleString("en-US",{minimumFractionDigits:2,maximumFractionDigits:2});

/* every <img> gets a labeled fallback if it fails to load */
function guardImages(root=document){
  root.querySelectorAll("img:not([data-guarded])").forEach(img=>{
    img.dataset.guarded="1";
    img.addEventListener("error",()=>{
      const box=img.parentElement; if(!box) return;
      const d=document.createElement("div");
      d.className="img-fallback";
      d.textContent=img.alt || "Image unavailable";
      img.replaceWith(d);
    },{once:true});
    if(img.complete && img.naturalWidth===0) img.dispatchEvent(new Event("error"));
  });
}
guardImages();

/* lenis */
scrollTo(0,0);
const lenis = new Lenis({ smoothWheel:true });
(function raf(t){ lenis.raf(t); requestAnimationFrame(raf); })(0);
let locks=0;
const lock=()=>{ locks++; lenis.stop(); document.documentElement.classList.add("is-locked"); };
const unlock=()=>{ locks=Math.max(0,locks-1); if(!locks){ lenis.start(); document.documentElement.classList.remove("is-locked"); } };

/* springs */
const springs=[];
class Spring{
  constructor(cfg,cb){ this.x=0;this.v=0;this.target=0;this.t=cfg[0];this.f=cfg[1];this.cb=cb;this.done=true;springs.push(this); }
  to(t){ this.target=t; this.done=false; }
  jump(v){ this.x=v;this.v=0;this.target=v;this.done=true;this.cb(v); }
  step(dt){
    if(this.done) return;
    const a=-this.t*(this.x-this.target)-this.f*this.v;
    this.v+=a*dt; this.x+=this.v*dt;
    if(Math.abs(this.x-this.target)<8e-4 && Math.abs(this.v)<8e-4){ this.x=this.target;this.v=0;this.done=true; }
    this.cb(this.x);
  }
}
let last=performance.now();
(function tick(now){ const dt=Math.min((now-last)/1000,.032); last=now; for(const s of springs) s.step(dt); requestAnimationFrame(tick); })(last);

function applyState(el,from,to,p){
  const g=k=>from[k]+(to[k]-from[k])*p;
  let t="";
  if("x" in from) t+=`translateX(${g("x")}px) `;
  if("y" in from) t+=`translateY(${g("y")}px) `;
  if("scale" in from) t+=`scale(${g("scale")}) `;
  if("rot" in from) t+=`rotate(${g("rot")}deg) `;
  if(t) el.style.transform=t;
  if("opacity" in from) el.style.opacity=g("opacity");
}
function makeSpring(el,from,to,cfg){
  const s=new Spring(cfg,p=>applyState(el,from,to,p));
  applyState(el,from,to,0);
  return s;
}

/* text reveals */
function buildWords(el,text){
  el.textContent="";
  const parts=text.split(" ");
  return parts.map((w,i)=>{
    const box=document.createElement("span"); box.className="clip";
    const inner=document.createElement("span"); inner.textContent=w;
    box.appendChild(inner); el.appendChild(box);
    if(i<parts.length-1) el.appendChild(document.createTextNode(" "));
    return box;
  });
}
function buildLines(el,text){
  el.textContent="";
  return text.split("|").map(l=>{
    const wrap=document.createElement("span"); wrap.className="line-wrap";
    const box=document.createElement("span"); box.className="clip";
    const inner=document.createElement("span"); inner.textContent=l;
    box.appendChild(inner); wrap.appendChild(box); el.appendChild(wrap);
    return box;
  });
}
function playClips(boxes,{stagger=120,duration=950,delay=0,ease=EASE.expo}={}){
  boxes.forEach((b,i)=>{
    b.firstElementChild.style.transition = RM ? "none"
      : `transform ${duration}ms ${ease} ${delay+i*stagger}ms, opacity ${duration}ms ${ease} ${delay+i*stagger}ms`;
    requestAnimationFrame(()=>b.classList.add("go"));
  });
}

const io=new IntersectionObserver(es=>{
  es.forEach(e=>{ if(e.isIntersecting){ io.unobserve(e.target); e.target._play&&e.target._play(); } });
},{ rootMargin:"0px 0px -8% 0px", threshold:.05 });
const inview=(el,fn)=>{ el._play=fn; io.observe(el); };

/* build categories */
const ARROW = `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14M13 6l6 6-6 6"/></svg>`;
document.getElementById("catList").replaceChildren(...CATS.map((c,i)=>{
  const items = PRODUCTS.filter(p=>p.cat===c.key);
  const low = Math.min(...items.map(p=>p.price));
  const li=document.createElement("li");
  li.innerHTML = `<a class="cat-row" href="${c.href}">
    <span class="cat-num">${c.n}</span>
    <span class="cat-main"><h3>${c.title}</h3><p>${c.desc}</p></span>
    <span class="cat-meta">${items.length} products · from ${money(low)}</span>
    <span class="cat-arrow">${ARROW}</span></a>`;
  const row=li.firstElementChild;
  const s=makeSpring(row,{opacity:0,y:26},{opacity:1,y:0},[190,26]);
  if(RM) applyState(row,{opacity:0,y:26},{opacity:1,y:0},1);
  else inview(row,()=>setTimeout(()=>s.to(1), i*90));
  const arrow=row.querySelector(".cat-arrow svg");
  const hs=makeSpring(arrow,{x:0,opacity:.55},{x:8,opacity:1},[300,20]);
  row.addEventListener("pointerenter",()=>canHover()&&hs.to(1));
  row.addEventListener("pointerleave",()=>hs.to(0));
  return li;
}));

/* build filters + grid */
const FILTERS=[{k:"all",l:"All"},{k:"portable",l:"Portable Power"},{k:"backup",l:"Home Backup"},{k:"ev",l:"EV Charging"}];
let active="all";
const filtersEl=document.getElementById("filters");
filtersEl.replaceChildren(...FILTERS.map(f=>{
  const b=document.createElement("button");
  b.type="button"; b.textContent=f.l; b.dataset.k=f.k;
  b.setAttribute("aria-pressed", String(f.k===active));
  b.addEventListener("click",()=>setFilter(f.k));
  return b;
}));

const gridEl=document.getElementById("grid");
gridEl.replaceChildren(...PRODUCTS.map((p,i)=>{
  const card=document.createElement("a");
  card.className="card"; card.dataset.cat=p.cat; card.href=P(p.handle);
  card.dataset.stock = p.stock ? "1" : "0";
  card.innerHTML = `
    <div class="media">
      ${p.featured&&p.stock ? '<span class="badge">Featured</span>' : ''}
      <img src="${p.img}" alt="${p.name}" loading="lazy">
    </div>
    <div class="body">
      <span class="brand">${p.brand}</span>
      <h3>${p.name}</h3>
      <p class="spec">${p.spec}</p>
      <div class="foot">
        <span><span class="price${p.stock?'':' struck'}">${money(p.price)}</span>${
          p.stock ? (p.from?' <span class="from">from</span>':'') : ' <span class="soldout">Sold out</span>'
        }</span>
        <span class="go">View</span>
      </div>
    </div>`;
  const s=makeSpring(card,{opacity:0,y:34},{opacity:1,y:0},[180,26]);
  if(RM) applyState(card,{opacity:0,y:34},{opacity:1,y:0},1);
  else inview(card,()=>setTimeout(()=>s.to(1), Math.min(i,8)*70));
  return card;
}));

guardImages(gridEl);

function setFilter(k){
  active=k;
  [...filtersEl.children].forEach(b=>b.setAttribute("aria-pressed",String(b.dataset.k===k)));
  [...gridEl.children].forEach(c=>{ c.hidden = !(k==="all" || c.dataset.cat===k); });
}

/* standards */
document.getElementById("stdGrid").replaceChildren(...STANDARDS.map(([t,b,tag],i)=>{
  const li=document.createElement("li");
  li.innerHTML=`<div class="std"><div><h3>${t}</h3><p>${b}</p></div><div class="tag">${tag}</div></div>`;
  const card=li.firstElementChild;
  const s=makeSpring(card,{opacity:0,y:40},{opacity:1,y:0},[180,26]);
  if(RM) applyState(card,{opacity:0,y:40},{opacity:1,y:0},1);
  else inview(card,()=>setTimeout(()=>s.to(1), i*120));
  return li;
}));

/* text reveal wiring */
document.querySelectorAll("[data-lines]").forEach(el=>{
  const boxes=buildLines(el, el.dataset.text || el.textContent.trim());
  if(el.classList.contains("gated")){ el._gate=()=>playClips(boxes,{stagger:110,duration:900,delay:350}); return; }
  if(RM){ boxes.forEach(b=>b.classList.add("go")); return; }
  inview(el,()=>playClips(boxes,{stagger:120,duration:950}));
});
document.querySelectorAll("[data-words]").forEach(el=>{
  const boxes=buildWords(el, el.textContent.trim());
  if(el.classList.contains("gated")){ el._gate=()=>playClips(boxes,{stagger:140,duration:1100}); return; }
  if(RM){ boxes.forEach(b=>b.classList.add("go")); return; }
  inview(el,()=>playClips(boxes,{stagger:140,duration:1100}));
});
document.querySelectorAll("[data-fade-words]").forEach(el=>{
  const text=el.textContent.trim(); el.textContent="";
  const words=text.split(" ").map(w=>{
    const s=document.createElement("span"); s.className="fadeword"; s.textContent=w;
    el.appendChild(s); el.appendChild(document.createTextNode(" ")); return s;
  });
  if(RM){ words.forEach(w=>w.classList.add("go")); return; }
  inview(el,()=>words.forEach((w,i)=>{
    w.style.transition=`transform 700ms ${EASE.quart} ${250+i*28}ms, opacity 700ms ${EASE.quart} ${250+i*28}ms`;
    requestAnimationFrame(()=>w.classList.add("go"));
  }));
});

/* hover springs */
document.querySelectorAll("[data-arrow]").forEach(b=>{
  const svg=b.querySelector("svg"); if(!svg) return;
  const s=makeSpring(svg,{x:0},{x:5},[320,20]);
  b.addEventListener("pointerenter",()=>canHover()&&s.to(1));
  b.addEventListener("pointerleave",()=>s.to(0));
});
document.querySelectorAll("[data-x-rotate]").forEach(b=>{
  const svg=b.querySelector("svg"); if(!svg) return;
  const s=makeSpring(svg,{rot:0},{rot:90},[300,18]);
  b.addEventListener("pointerenter",()=>canHover()&&s.to(1));
  b.addEventListener("pointerleave",()=>s.to(0));
});

/* hero featured rotator */
const featured = PRODUCTS.filter(p=>p.featured && p.stock);
const pcard=document.getElementById("pcard");
let fi=0, ftimer=null;
function paintFeatured(i){
  const p=featured[i];
  pcard.href=P(p.handle);
  pcard.querySelector(".pcard-img").innerHTML=`<img src="${p.img}" alt="${p.name}">`;
  guardImages(pcard);
  pcard.querySelector(".pcard-cat").textContent=p.brand;
  pcard.querySelector(".pcard-name").textContent=p.name;
  pcard.querySelector(".pcard-price").textContent=money(p.price);
}
function cycle(){
  if(RM){ fi=(fi+1)%featured.length; paintFeatured(fi); return; }
  const out=makeSpring(pcard,{opacity:1,y:0,scale:1},{opacity:0,y:16,scale:.96},[210,24]); out.to(1);
  setTimeout(()=>{
    springs.splice(springs.indexOf(out),1);
    fi=(fi+1)%featured.length; paintFeatured(fi);
    const inS=makeSpring(pcard,{opacity:0,y:16,scale:.96},{opacity:1,y:0,scale:1},[210,24]); inS.to(1);
    setTimeout(()=>springs.splice(springs.indexOf(inS),1),900);
  },260);
}
paintFeatured(0);

/* smooth scroll */
document.addEventListener("click",e=>{
  const a=e.target.closest("[data-scroll]"); if(!a) return;
  const t=document.querySelector(a.getAttribute("href")); if(!t) return;
  e.preventDefault(); closeMenu(); lenis.scrollTo(t,{offset:-8});
});

/* the host theme supplies site navigation; no in-section menu */
function closeMenu(){}

/* loader */
const loader=document.getElementById("loader");
const MIN=RM?200:1400, MAX=2600, EXIT=RM?0:850;
if(loader){
  lock();
  const mark=loader.querySelector(".loader-mark");
  if(mark) makeSpring(mark,{opacity:0,y:16},{opacity:1,y:0},[200,22]).to(1);
  const fill=loader.querySelector(".loader-fill");
  if(fill){
    if(!RM){ fill.style.transition=`transform ${MIN-120}ms ${EASE.cubic} 120ms`; requestAnimationFrame(()=>fill.style.transform="scaleX(1)"); }
    else fill.style.transform="scaleX(1)";
  }
}

const heroPhotoS=makeSpring(document.getElementById("heroPhoto"),{opacity:0,x:56},{opacity:1,x:0},[140,30]);
const psliderS=makeSpring(document.getElementById("pslider"),{opacity:0,y:28},{opacity:1,y:0},[200,26]);
const freightS=makeSpring(document.getElementById("freightCard"),{opacity:0,y:28},{opacity:1,y:0},[200,26]);

let started=false;
function start(){
  if(started) return; started=true;
  document.querySelectorAll(".gated").forEach(el=>{ el.classList.add("ready"); el._gate&&el._gate(); });
  if(!RM) requestAnimationFrame(()=>document.getElementById("hazardRule").classList.add("go"));
  else document.getElementById("hazardRule").style.transform="scaleX(1)";
  if(RM){ heroPhotoS.jump(1); psliderS.jump(1); freightS.jump(1); }
  else { setTimeout(()=>heroPhotoS.to(1),120); setTimeout(()=>psliderS.to(1),650); setTimeout(()=>freightS.to(1),780); }
  if(!RM && featured.length>1) ftimer=setInterval(cycle,4200);
  if(loader){
    unlock();
    if(EXIT) loader.classList.add("out"); else loader.style.display="none";
    setTimeout(()=>{ loader.remove(); }, EXIT+50);
  }
}
// last-resort safety: never leave the page scroll-locked
setTimeout(()=>{ if(!started){ started=false; start(); } }, MAX+1200);
addEventListener("error", () => {
  document.documentElement.classList.remove("is-locked");
  try { lenis.start(); } catch(e){}
});
if(document.readyState==="complete") setTimeout(start,MIN);
else addEventListener("load",()=>setTimeout(start,MIN));
setTimeout(start,MAX);